// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__XeJVE","error":"Notification_error__q4ynK","success":"Notification_success__3ZpuI"};